import { urlEscaped } from '@app/utils/urlEscaped'

import { createApiAction } from '@app/packages/api/utils'
import type { ApiDocument } from '@app/packages/api/v2/types/entities'
import type { PostDocumentsRequest } from '@app/packages/api/v2/types/params'

import { createPostDocumentsData } from './documents.utils'
import { postEncryptionPublicKeys } from './encryption'

export const getDocuments = () =>
  createApiAction('getDocuments', dispatch => dispatch<{ data: ApiDocument[] }>({ method: 'GET', endpoint: '/api/v2/documents' }))

export const getDocumentsById = (id: string) =>
  createApiAction('getDocumentsById', dispatch => dispatch<{ data: ApiDocument }>({ method: 'GET', endpoint: urlEscaped`/api/v2/documents/${id}` }))

/** The file is encrypted against a key this endpoint hands out first, so the upload is two calls. */
export const postDocuments = (request: PostDocumentsRequest) =>
  createApiAction('postDocuments', async dispatch => {
    const keyData = await postEncryptionPublicKeys()(dispatch)
    const body = await createPostDocumentsData(request.file, request.type, keyData.data)
    return await dispatch<{ data: ApiDocument }>({ method: 'POST', endpoint: '/api/v2/documents', body })
  })
